let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Xy5T")).then(() => parcelRequire('22Hs1'));